import styled from "styled-components";
import { margin } from "styled-system";

export const StyledViewContainer = styled.div`
  ${margin}
  flex-direction: row;
`;
